export default {
  cart: {
    account: 'Penyelesaian'
  },
  tips: {
    cart_success: "Produk telah ditambahkan ke keranjang belanja",
    add_success: "Produk telah ditambahkan ke keranjang belanja",
    empty: "Kosong ~",
    order_success: "Selamat, pesanan berhasil dikirim",
    chose: "Silakan pilih variasi produk terlebih dahulu",
    un_pay_on_line: "Tidak mendukung pembayaran online",
    area_not_empty: "Silakan masukkan kecamatan",
    name_not_empty: "Silakan masukkan nama kamu",
    address_not_empty: "Silakan masukkan alamat",
    phone_not_empty: "Nomor Telepon Tidak Sah"
  },
  detail: {
    carriage: 'Total Ongkos Kirim',
    surplus: 'tersisa',
    goods_detail: 'Deskripsi Produk',
    cart: 'Tampilkan Keranjang Belanja',
    mange:'pengelolaan',
    add_cart: 'masukkan keranjang',
    CloseOrder:'Selesaikan pesanan',
    buy_now: 'beli sekarang',
    Subtotal:'Subtotal',
    Total:'total',
    jian:'Potongan',
    Delivery_method:'Opsi Pengiriman',
    paypaly_method:'Metode Pembayaran',
    paypaly1:'Cash on delivery',
    paypaly2:'Membayar',
    paypalyOut:'Dalam perkembangannya, harap tunggu dengan sabar'
  },
  order: {
    freeFreight:'Bebas barang',
    allTotal:'Jumlah harga barang',
    query:'Pertanyaan perintah',
    goods_info: 'Informasi produk',
    pay_way: 'Pilih metode pengiriman dan pembayaran',
    offline: 'Cash on Delivery',
    online: 'Pembayaran Online',
    pick_info: 'Informasi pengiriman',
    name_name: 'Nama Kamu/Toko',
    name: 'Name Kamu/Toko',
    phone_name: 'Nomor Telepon',
    phone: 'Nomor  Telepon',
    area: 'Provinsi  Kota  Kecamatan ',
    region: 'Kecamatan',
    address_name: 'Nama gedung, jalan dan lainnya...',
    address: 'Nama gedung, jalan dan lainnya...',
    offer_order: 'Buat Pesanan',
  },
  data: {
    Recipient_name:'Nama Kamu/Toko',
    Recipient_nameTips:'Harap isi nama asli penerima untuk memastikan kelancaran penerimaan',
    Select_M:'Pilih toko',
    email:"Kotak surat penerima",
    Select_M_number:'Nama toko',
    Selected_store_name:'Pilih nama toko',
    Shop_address:'alamat toko',
    address:'Silakan pilih alamat',
    Choose_payment_method:'Metode Pembayaran',
    default_address:'Taiwan',
  },
  indexdata:{
    index:'Halaman muka',
    list:'Daftar',
    placeholder:'Masukkan kata kunci pencarian',
    Return:'kembali'
  },
  Product_details_page: {
    guarantee:'mengganti rugi',
    guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
    numbertext:'Kuantitas',
    Select_product_specification:'Silakan pilih variasi produk terlebih dahulu',
    Package_selection: 'Pemilihan paket',
    Buy_now: 'Beli Sekarang'
  },
  newOrder:{
    Order_information:'Produk Dipesan',
    Selection_of_delivery_and_payment_methods:'Pilih metode pengiriman dan metode pembayaran',
    Delivery_place:'Alamat Pengiriman',
    tw:'Taiwan',
    Delivery_method:'Metode Pengiriman',
    Sub_total:'subtotal',
    Freight_charges:'barang',
    Total:'Total Pembayaran',
    Go_to_checkout:'Pergi ke pemukiman',
  },
  order3: {
    Total:'otal Pembayaran',
    Delivery_information:'Informasi pengiriman',
    Freight_charges:'barang',
    change:'perubahan',
    Search_shop:'Cari toko',
    Order_notes:'memesan catatan',
    Payment_information:'Profil pembayaran',
    Payment_method_selected:'Metode pembayaran dipilih',
    Submit_order: 'Buat Pesanan',
    xxdz:'Harap masukkan alamat rinci',
    Select_address: 'Pilih alamat',
    Tell_the_seller:'Tinggalkan pesan ke penjual？',
    freight:"Total Ongkos Kirim",
    Spesifikasi_jualan_pendek:'Spesifikasi ini sudah habis terjual',
  },
  index:{
    placeholder:'Silakan masukkan kata kunci pencarian',
    index:'Daftar Beranda',
    list: 'Daftar',
    language:'Pilih bahasa'
  },
  Guarantee:{
    num:'Kuantitas',
    Pickup_method:'Dukungan 7-11, penjemputan toko keluarga',
    Guarantee:'Kualitas asuransi',
    Freight:'Gratis Ongkir',
    Commodity_pic:'Komoditas Circle',
    Options:'Pilihan',
    selected:'terpilih',
    Total_price:'Total Pembayaran:',
    Finally_cope:'Total Pembayaran',
    message:'Tinggalkan pesan ke penjual',
    region:'Kota Kecamatan',
    region_s:'Provinsi  Kota  Kecamatan',
    country:'daerah negara '
  },
  Pay:{
    language:'Cash on delivery',
    money:'Rp',
    to:'Lompat ke beranda dalam  detik',
    postcode:'Kode Pos',
    setMeal:'Harga paket kombinasi',
    success:'berhasil dipesan!',
    time:'Pedagang akan secara otomatis mengkonfirmasi pesanan Anda dalam 10 menit!',
    realMoney:'Jumlah yang sebenarnya dibayarkan',
    orderNumber:'Jumlah order',
    waitFor:'Pedagang tidak mengirimkan barang, harap tunggu dengan sabar'
  },
  comment:{
    comment:'Komentar',
    Praise:'5 bintang ',
    Average:'3 bintang ',
    Badreview:'1 bintang ',
    submitcomments:'kirimkan komentar',
    PleaseEnteraComment:'Silakan masukkan komentar'
  },
  Toast:{
    inputName:'Silakan masukkan nama kamu',
    inputPhone:'Nomor Telepon Tidak Sah',
    inputZip:'Silakan masukkan kode pos',
    inputAddress:'Silakan masukkan alamat',
    inputAlertAddress:'Alamat ini bukan pengiriman, harap ubah ke alamat lain',
  },
  contactUs:{
    callMe:`Tanyakan kepada kami, <br> Anda dapat menghubungi Messenger di halaman penggemar!`,
    afterShop:`Sudah berbelanja, Anda bisa menghubungi:<br>Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
    confirm:'Konfirmasi',
    shortSale:'Spesifikasi ini sudah habis terjual',
  },
  ensure:{
    introduce:'Perkenalan produk',
    Specifications:'Spesifikasi komoditas',
    ensure:'Garansi bahan bakar',
    di:'',
    commodity:'th item'
  },
  wuliu:{
    orderSearch:'订单查询',
    provide:'本數據由物流官方提供',
    OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
    orderPlaceho:'填寫相關訊息查詢',
    query:'查询订单号',
    Tips:'温馨提示',
    Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
  }
}


// WEBPACK FOOTER //
// ./src/i18n/is.js